import React,{useState,useEffect,useRef} from 'react'
import './fromSecondPart.css'
import { Select, Form, Typography} from "antd";
import downArrow from "../../../../../assets/icons/downArrow.svg"

const TaxTerm = ({ taxTermValue, handleValue }) => {
  const { Option } = Select;
  const { Text } = Typography;
  // const [taxTerm, setTaxTerm] = useState(null);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChange = (val) => {
    // setTaxTerm(val);
    handleValue(val);
  };

  return (
    <div className="tax-term-div" style={{ paddingTop: "8px" }}>
      <div className="taxTerm-div">
        <Form.Item
          className="select-TaxItem"
          name="IdealTerms"
          rules={[
            {
              required: true,
              message: "Select tax term",
            },
          ]}
          label={
            <Text className="TaxTerm-label">
              Tax Term <strong>*</strong>
            </Text>
          }
          style={{width: windowDimensions.width > 900 ? "354px":
            windowDimensions.width >= 770 && windowDimensions.width <= 900 ?
             "354px" : ""}}
        >
          <Select
            style={{border: "solid 1px #d4d4d4"}}
            defaultValue={taxTermValue}
            placeholder={
              <div style={{ display: "flex", justifyContent: "space-between"}}>
                <div>Select tax term</div>
                <div>
                  <img src={downArrow} />
                </div>
              </div>
            }
            onChange={handleChange}
            mode="multiple"
          >
            {/* <Option value={'W-2'}>W-2</Option> */}
            {/* <Option value={'1099/Corp-to-Corp'}>Corp-to-Corp</Option> */}
            <Option value={'W-2'}>W-2</Option>
            <Option value={'1099/Corp-to-Corp'}>1099/Corp-to-Corp</Option>
          </Select>
        </Form.Item>
      </div>
    </div>
  );
};

export default TaxTerm;
